module.exports = __webpack_public_path__ + "static/media/hero__universities.333a6e03.jpg";